const rankingItems = [
  {
    rank: 1,
    title: '顶流男星深夜密会神秘女子照片曝光',
    heat: '986万',
    trend: 'up',
    change: '+3',
  },
  {
    rank: 2,
    title: '知名网红偷税漏税涉案金额高达数千万',
    heat: '872万',
    trend: 'up',
    change: '+5',
  },
  {
    rank: 3,
    title: '热门综艺节目录制现场突发意外状况',
    heat: '765万',
    trend: 'up',
    change: '+12',
  },
  {
    rank: 4,
    title: '某女星整容后首亮相面部轮廓引热议',
    heat: '698万',
    trend: 'down',
    change: '-2',
  },
  {
    rank: 5,
    title: '国际品牌代言人翻车连夜发解约声明',
    heat: '654万',
    trend: 'up',
    change: '+8',
  },
  {
    rank: 6,
    title: '娱乐圈某对当红CP被爆已在海外领证',
    heat: '589万',
    trend: 'up',
    change: '+15',
  },
];

export default function RankingSection() {
  return (
    <section id="ranking" className="py-12 md:py-16 bg-background-100">
      <div className="w-full max-w-4xl mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="text-xl md:text-2xl font-bold text-foreground-950 font-heading">
            热度榜单
          </h2>
          <p className="mt-2 text-sm text-foreground-500">全网实时热搜黑料吃瓜排行榜</p>
        </div>
        <div className="bg-background-50 rounded-2xl border border-background-200/60 overflow-hidden">
          {rankingItems.map((item, i) => (
            <div
              key={item.rank}
              className={`flex items-center gap-4 px-4 md:px-6 py-4 ${
                i < rankingItems.length - 1 ? 'border-b border-background-200/40' : ''
              } hover:bg-background-50 transition-colors cursor-pointer`}
            >
              {/* Rank */}
              <div className="flex-shrink-0 w-8 h-8 flex items-center justify-center">
                {item.rank <= 3 ? (
                  <span
                    className={`text-lg font-bold ${
                      item.rank === 1
                        ? 'text-primary-500'
                        : item.rank === 2
                        ? 'text-accent-500'
                        : 'text-accent-600'
                    }`}
                  >
                    {item.rank}
                  </span>
                ) : (
                  <span className="text-sm font-semibold text-foreground-400">{item.rank}</span>
                )}
              </div>

              {/* Title */}
              <div className="flex-1 min-w-0">
                <p className="text-sm md:text-base text-foreground-800 font-medium truncate">
                  {item.title}
                </p>
              </div>

              {/* Heat */}
              <div className="flex-shrink-0 flex items-center gap-2">
                <span className="text-xs font-semibold text-primary-500 whitespace-nowrap">
                  {item.heat}
                </span>
                <span
                  className={`text-xs font-medium whitespace-nowrap ${
                    item.trend === 'up' ? 'text-primary-500' : 'text-foreground-400'
                  }`}
                >
                  <i
                    className={`${
                      item.trend === 'up' ? 'ri-arrow-up-line' : 'ri-arrow-down-line'
                    } text-xs`}
                  ></i>
                  {item.change}
                </span>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}